import React/*, { useState, useEffect } */ from "react";
import { HomeComponent } from "../components";

function HomeContainer({ itemsArray }) {
  const redirigir = (url) => {
    window.open(url, "_blank")
  }
  return <HomeComponent items={redirigir}/>;
}

export default HomeContainer;
